import React from 'react'

export default function Footer() {
    return (
        <footer className="text-center mt-4">
        <p>© Innovative Construction Services, LLC</p>
      </footer>
    )
}
